"use strict";
/*!
 *
 * utility.ts
 *
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
// Break point setting.
var breakPoint = [768, 992, 1200];
var gap = {
    element: document.getElementById('Header'),
    spelement: document.getElementById('Header'),
    viewport: {
        phone: true,
        tablet: true,
        desktop: true,
        largeDesktop: true
    }
};
var util = {
    ua: {
        isTablet: false,
        isPhone: false
    },
    ww: window.innerWidth,
    wh: window.innerHeight,
    hash: location.hash,
    viewport: 'desktop',
    scroller: 'html,body',
    scrollGap: 10,
    isTouchDevice: false,
    lang: document.documentElement.lang
};
util.ua = (function (u) {
    return {
        isTablet: (u.indexOf('windows') != -1 && u.indexOf('touch') != -1) ||
            u.indexOf('ipad') != -1 ||
            (u.indexOf('android') != -1 && u.indexOf('mobile') == -1) ||
            (u.indexOf('firefox') != -1 && u.indexOf('tablet') != -1) ||
            u.indexOf('kindle') != -1 ||
            u.indexOf('silk') != -1 ||
            u.indexOf('playbook') != -1,
        isPhone: (u.indexOf('windows') != -1 && u.indexOf('phone') != -1) ||
            u.indexOf('iphone') != -1 ||
            u.indexOf('ipod') != -1 ||
            (u.indexOf('android') != -1 && u.indexOf('mobile') != -1) ||
            (u.indexOf('firefox') != -1 && u.indexOf('mobile') != -1) ||
            u.indexOf('blackberry') != -1
    };
})(window.navigator.userAgent.toLowerCase());
util.viewport = (function () {
    if (util.ww < breakPoint[0]) {
        return 'phone';
    }
    else if (util.ww >= breakPoint[0] && util.ww < breakPoint[1]) {
        return 'tablet';
    }
    else if (util.ww >= breakPoint[1] && util.ww < breakPoint[2]) {
        return 'desktop';
    }
    else if (util.ww >= breakPoint[2]) {
        return 'largeDesktop';
    }
    ;
})();
function setScrollGap() {
    if (gap.viewport[util.viewport]) {
        if (gap.element !== null) {
            if (util.viewport !== 'tablet' && util.viewport !== 'phone') {
                return 90 + 30;
                //return 60;
            }
            else {
                return 65 + 20;
            }
        }
        else {
            return 90 + 30;
        }
        ;
    }
    else {
        return 65 + 20;
    }
    ;
}
;
util.scrollGap = setScrollGap();
var html = document.documentElement;
var body = document.querySelector('body');
var setSize = function () {
    var vh = window.innerHeight * 0.01;
    html.style.setProperty('--vh', vh + "px");
    if (window.innerWidth > body.clientWidth + 5) {
        var scrollbar = window.innerWidth - body.clientWidth;
        html.style.setProperty('--scroll-bar', scrollbar + "px");
    }
    ;
};
setSize();
var custom_event_1 = __importDefault(require("custom-event"));
var viewportChanged = new custom_event_1.default('viewportChanged');
window.addEventListener('resize', function () {
    util.wh = window.innerHeight;
    util.ww = window.innerWidth;
    if (util.viewport !== 'phone' && util.ww < breakPoint[0]) {
        util.viewport = 'phone';
        util.scrollGap = setScrollGap();
        window.dispatchEvent(viewportChanged);
    }
    ;
    if (util.viewport !== 'tablet' && util.ww >= breakPoint[0] && util.ww < breakPoint[1]) {
        util.viewport = 'tablet';
        util.scrollGap = setScrollGap();
        window.dispatchEvent(viewportChanged);
    }
    ;
    if (util.viewport !== 'desktop' && util.ww >= breakPoint[1] && util.ww < breakPoint[2]) {
        util.viewport = 'desktop';
        util.scrollGap = setScrollGap();
        window.dispatchEvent(viewportChanged);
    }
    ;
    if (util.viewport !== 'largeDesktop' && util.ww >= breakPoint[2]) {
        util.viewport = 'largeDesktop';
        util.scrollGap = setScrollGap();
        window.dispatchEvent(viewportChanged);
    }
    ;
    setSize();
});
var CSSLoad = new custom_event_1.default('CSSLoad');
var monitorElem = document.getElementsByTagName('html')[0];
var style = window.getComputedStyle(monitorElem);
var monitor = setInterval(function () {
    if (style.lineHeight !== '1.2375') {
        util.scrollGap = setScrollGap();
        window.dispatchEvent(CSSLoad);
        clearInterval(monitor);
        setSize();
    }
    ;
}, 10);
window.addEventListener('load', function () {
    util.scrollGap = setScrollGap();
});
if (window.ontouchstart === null) {
    util.isTouchDevice = true;
    var body_1 = document.getElementsByTagName('body')[0];
    //body.className = 'is-touchdevice';
    body_1.setAttribute('ontouchstart', '');
}
;
module.exports = util;
